import { Container, Grid, Box, Card, CardContent } from '@mui/material';
import MKTypography from 'components/MKTypography';
import MKButton from 'components/MKButton';
import Card2 from '../../../../assets/card/IMG_1486.png';
import springboot from '../../../../assets/card/SPRING BOOT.png';
import python from '../../../../assets/card/PYTHON.png';
import angular from '../../../../assets/card/ANGULAR.png';
import react from '../../../../assets/card/REACT.png';
import Mysql from '../../../../assets/card/MY SQL.png';
import Mnet from '../../../../assets/card/NET.png';

function BlogCard2() {
  return (
    <Box
      id="servicios"
      sx={{
        position: 'relative',
        // width: "110%",
        minHeight: '100vh',
        backgroundImage: `url(${Card2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        // backgroundAttachment: "fixed",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 0',
        zIndex: 1,
        marginLeft: '-16px',
        marginRight: '-16px',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(30, 46, 61, 0.85)', // opacidad
          zIndex: 2,
        }}
      />

      <Container sx={{ position: 'relative', zIndex: 3 }}>
        <MKTypography variant="h3" align="center" fontWeight="bold" color="white" mt={-3} mb={1}>
          SERVICIOS
        </MKTypography>

        <MKTypography variant="body2" align="center" color="white" mb={5}>
          Hacemos parte de todo el proceso para lograr las capacidades tecnológicas que tu
          organización necesita:
        </MKTypography>

        <Grid container spacing={7} data-aos="fade-up">
          {/* Tarjeta 1 */}
          <Grid item xs={12} lg={4}>
            <Card
              sx={{
                height: 470,
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: 'rgba(8, 226, 255, 0.13)',
                boxShadow: 'none',
                padding: '40px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.10)',
                  boxShadow: '0px 10px 20px rgba(255, 255, 255, 0.2)',
                },
              }}
            >
              <MKTypography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                CONSULTORÍA
              </MKTypography>
              <CardContent>
                <MKTypography variant="body2" color="white" fontSize="17px">
                  Acompañamos la identificación de necesidades tecnológicas, definiciones
                  estratégicas y estructuración de requerimientos técnicos.
                </MKTypography>
                <ul
                  style={{
                    paddingLeft: '20px',
                    marginTop: '29px',
                    fontSize: '15px',
                    color: 'white',
                  }}
                >
                  <li>Ingeniería de software</li>
                  <li>Arquitectura empresarial</li>
                  <li>Arquitectura y diseño de software</li>
                  <li>Sistemas de mando y control</li>
                  <li>Transformación digital</li>
                </ul>
              </CardContent>
            </Card>
          </Grid>

          {/* Tarjeta 2 */}
          <Grid item xs={12} lg={4}>
            <Card
              sx={{
                height: 470,
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: 'rgba(8, 226, 255, 0.13)',
                border: '2px solid #08E2FF',
                boxShadow: 'none',
                padding: '40px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.10)',
                  boxShadow: '0px 10px 20px rgba(255, 255, 255, 0.2)',
                },
              }}
            >
              <MKTypography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                DISEÑO Y DESARROLLO
              </MKTypography>
              <CardContent>
                <MKTypography variant="body2" color="white" fontSize="17px">
                  Transformamos ideas en realidad al crear soluciones tecnológicas de principio a
                  fin, personalizadas y con diferentes lenguajes de programación.
                </MKTypography>
                <ul
                  style={{
                    paddingLeft: '20px',
                    marginTop: '25px',
                    fontSize: '15px',
                    color: 'white',
                  }}
                >
                  <li>Diseño de productos</li>
                  <li>Diseño y desarrollo de productos de software</li>
                  <li>Servicios de desarrollo a medida</li>
                </ul>
              </CardContent>
            </Card>
          </Grid>

          {/* Tarjeta 3 */}
          <Grid item xs={12} lg={4}>
            <Card
              sx={{
                height: 470,
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: 'rgba(8, 226, 255, 0.13)',
                boxShadow: 'none',
                padding: '40px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.10)',
                  boxShadow: '0px 10px 20px rgba(255, 255, 255, 0.2)',
                },
              }}
            >
              <MKTypography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                OUTSOURCING
              </MKTypography>
              <CardContent>
                <MKTypography variant="body2" color="white" fontSize="17px">
                  Apoyamos tu operación con nuestro talento experto en un amplio portafolio de
                  tecnologías.
                </MKTypography>

                <Box sx={{ display: 'flex', gap: 2, marginTop: 5 }}>
                  <img
                    src={springboot}
                    alt="Spring Boot"
                    width={100}
                    height={40}
                    style={{ marginRight: '15px' }}
                  />
                  <img src={python} alt="Python" width={100} height={30} />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, marginTop: 5 }}>
                  <img src={angular} alt="Angular" width={100} height={50} />
                  <img
                    src={react}
                    alt="React"
                    width={110}
                    height={40}
                    style={{ marginLeft: '0px' }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
                  <img src={Mysql} alt="MySQL" width={100} />
                  <img src={Mnet} alt="NET" width={100} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 5, gap: 7 }}>
          {/* <MKButton variant="contained" size="large">
            Ver casos
          </MKButton> */}

          <MKButton
            variant="contained"
            size="large"
            onClick={() => {
              const targetElement = document.getElementById('contact-us');
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            CUÉNTANOS QUÉ NECESITAS
          </MKButton>
        </Box>
      </Container>
    </Box>
  );
}

export default BlogCard2;
